export default __webpack_public_path__ + "static/media/outing.c9976fe5.png";